import types from "../types";

const initial = {
  data: [],
  filters: { published: true },
  total: 0,
};

export const product_reducer = (state = initial, { type, payload }) => {
  switch (type) {
    case types.PRODUCT:
      const uniqueData = Array.isArray(payload.data)
        ? payload.data.filter(
            (product, index, self) =>
              index === self.findIndex((p) => p._id === product._id)
          )
        : [];
      return {
        ...state,
        data: uniqueData,
        total: payload.total || 0,
      };
    case types.PRODUCT_RESET:
      return initial;
    default:
      return state;
  }
};
